/**
 * Real Google Reviews — used for visible Reviews section + JSON-LD schema.
 * Each review has: author, vehicle, rating, datePublished, body.
 */

const reviews = [
  {
    author: 'Andrew Stein',
    vehicle: '2021 Porsche Macan GTS',
    rating: 5,
    datePublished: '2025-10-15',
    body: 'SSF is amazing — I strongly recommend them! I have an all-black 2021 Porsche Macan GTS with 5 years of grit, grime, swirl marks, and road-trip wear and tear. Steven was very professional about walking through the various options and what would deliver the best results. The paint correction and ceramic coating turned my Macan back into showroom condition. Easily the best detail I have ever had.',
  },
  {
    author: 'Rob Cohen',
    vehicle: '2025 BMW M440i Grand Coupe',
    rating: 5,
    datePublished: '2025-08-20',
    body: 'Saw a professional ad on social media and drove from Ogunquit, ME to Delray Beach, FL just for SSF Detail. Our 2025 BMW M440i Grand Coupe needed a detail including a boost on the ceramic coating and full interior. Steven and the team delivered above and beyond. Worth the trip — the car looks better than the day we picked it up from the dealer.',
  },
  {
    author: 'Tracy Hearn',
    vehicle: 'Toyota Tacoma',
    rating: 5,
    datePublished: '2025-10-05',
    body: 'I just had my truck ceramic coated with Steven and the guys at SSF Detail. They did an amazing job! From start to finish, he was very professional, knowledgeable, and patient with my hundreds of questions. He takes pride in his work and it shows in the finished result. My new Tacoma looks incredible.',
  },
  {
    author: 'Susannah Blount',
    vehicle: 'BMW',
    rating: 5,
    datePublished: '2025-07-15',
    body: 'I am absolutely thrilled with the work SSF Detail did on my BMW. I came in with severe oil and sun damage, and they transformed my vehicle to the point where it looks brand new again. They performed a ceramic coating on the body and a full restoration. The level of attention to detail was beyond what I expected. Highly recommend them to anyone with a luxury vehicle.',
  },
  {
    author: 'Stan Gordon',
    vehicle: 'Mercedes-Benz GLE AMG 63s',
    rating: 5,
    datePublished: '2025-06-10',
    body: 'I was extremely satisfied with SSF Detail. My GLE AMG 63s came out spectacular and shining like a mirror. These guys are very professional and caring — a pleasure to deal with. I highly recommend them for any luxury vehicle owner in South Florida.',
  },
  {
    author: 'Jeff Adams',
    vehicle: 'Mercedes-Benz AMG SL43 (Turquoise)',
    rating: 5,
    datePublished: '2025-09-12',
    body: 'Steven was a pleasure to deal with. He is professional and knowledgeable. My Mercedes AMG SL43 in turquoise was brand new straight from the dealer and looked great, but when Steven got done with it, it looked unbelievable. I am extremely happy with the work and the protection it now has.',
  },
  {
    author: 'Lou',
    vehicle: '2013 BMW M3',
    rating: 5,
    datePublished: '2025-09-25',
    body: 'Had PPF done on my 2013 M3 and was blown away by the finish, not to mention the fact that it will help protect my front end from small debris when driving. The STEK paint protection film install was flawless. Going back for paint correction next!',
  },
  {
    author: 'Andre Garcia',
    vehicle: '2025 Tesla Model 3 & 2019 Mercedes-Benz GLS450',
    rating: 5,
    datePublished: '2025-05-18',
    body: "I first had my son's brand new 2025 Tesla Model 3 done. After I saw the results I had my 2019 Mercedes GLS450 completed. I still love what they did. I get plenty of looks on my 2019. If you have an older car and want that brand new look, SSF Detail is the place to go.",
  },
  {
    author: 'Salena Maharaj',
    vehicle: 'Ford Bronco',
    rating: 5,
    datePublished: '2025-11-10',
    body: 'SSF Detailing did an exceptional job on my Bronco, demonstrating a level of craftsmanship and care that is truly rare. Every surface was meticulously cleaned, with clear attention paid to even the smallest details, leaving the vehicle looking flawless. Their professionalism and precision reflect a genuine pride in their work, and it shows in the final result. Definitely looking forward to working with them again.',
  },
];

export default reviews;
